// @ts-check
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';
import { getRegionsAction } from '../redux/actions/region-actions';

import { makeStyles } from '@material-ui/core/styles';

import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';

import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { LoadingComponent } from '../components/loading-component.js';
import { FloatingActionButtonSize } from '../components/add-component';
import MapIcon from '@material-ui/icons/Map';
import { BackNavigationComponent } from '../../../../core/routes/components/back-navigation-component';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(0),
    width: '100%',
    backgroundColor: theme.palette.background.paper
  },

  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    cursor: 'pointer'
  },
  container: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  }
}));

function Region({ region }) {
  const classes = useStyles();
  const history = useHistory();
  return (
    <Paper
      className={classes.paper}
      elevation={0}
      onClick={() => history.push(`/regions/${region.id}/view`)}
    >
      <MapIcon fontSize="large" />

      <div>
        <b>{region.name}</b>
      </div>
    </Paper>
  );
}

function RegionsList({ regions }) {
  const renderRegions = regions.map((value, key) => {
    return (
      <Grid key={key} item xs={6} md={4}>
        <Region region={value} />
      </Grid>
    );
  });

  return (
    <Grid container spacing={2}>
      {renderRegions}
    </Grid>
  );
}

export default function RegionsPage() {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { regions, loading } = useSelector((state) => state.regions);

  useEffect(() => {
    dispatch(getRegionsAction());
  }, [dispatch]);

  return (
    <>
      <React.Fragment>
        <CssBaseline />
        <Container className={classes.container}>
          {loading && <LoadingComponent />}
          {!loading && (
            <>
              <BackNavigationComponent page="Regions" uri="/" />
              <FloatingActionButtonSize />
              <RegionsList regions={regions} />
            </>
          )}
        </Container>
      </React.Fragment>
    </>
  );
}
